import { render, staticRenderFns } from "./PopupController.vue?vue&type=template&id=2f707ff0&scoped=true&"
import script from "./PopupController.vue?vue&type=script&lang=js&"
export * from "./PopupController.vue?vue&type=script&lang=js&"
import style0 from "./PopupController.vue?vue&type=style&index=0&id=2f707ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f707ff0",
  null
  
)

export default component.exports